import axios from 'axios';
import config from '../config';

const service = axios.create({
  baseURL: '/', // 可根据需要调整
  timeout: 10000
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可在此处添加token等
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => response.data,
  error => {
    return Promise.reject(error);
  }
);

export function fullImageUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // 保证只有一个斜杠
  return config.IMG_BASE_URL + (path.startsWith('/') ? path : '/' + path);
}

export function fixRichTextImg(html) {
  if (!html) return '';
  // 兼容 /profile/upload/ 和 /dev-api/profile/upload/
  return html.replace(/src="(\/(?:dev-api\/)?profile\/upload[^"]*)"/g, (match, p1) => {
    // 去掉/dev-api前缀
    const cleanPath = p1.replace(/^\/dev-api/, '');
    return `src="${config.IMG_BASE_URL}${cleanPath}"`;
  });
}

export default service; 